document.addEventListener('click', async (event) => {
  const button = event.target.closest('#LoadMoreButton');
  if (!button) return;

  event.preventDefault();

  if (button.dataset.loading === 'true') return;

  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const nextUrl = button.dataset.nextUrl;
  const sectionId = button.dataset.sectionId;

  if (!nextUrl || !sectionId) return;

  const text = button.querySelector('.load-more-text');
  const spinner = button.querySelector('.load-more-spinner');

  button.dataset.loading = 'true';
  button.disabled = true;

  if (text) text.textContent = 'Loading...';
  if (spinner) spinner.hidden = false;

  try {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const incomingGrid = doc.getElementById('product-grid');
    const incomingButton = doc.getElementById('LoadMoreButton');
    const incomingCount = doc.getElementById('ProductCountDesktop');
    const currentCount = document.getElementById('ProductCountDesktop');

    const incomingProgressText = doc.getElementById('ProductProgressText');
    const currentProgressText = document.getElementById('ProductProgressText');

    const incomingProgressBarFill = doc.getElementById('ProductProgressBarFill');
    const currentProgressBarFill = document.getElementById('ProductProgressBarFill');

    if (!incomingGrid) {
      throw new Error('Missing #product-grid in response');
    }

    incomingGrid.querySelectorAll('li.grid__item').forEach((item) => {
      grid.appendChild(item);
    });

    if (currentCount && incomingCount) {
      currentCount.innerHTML = incomingCount.innerHTML;
    }

    if (currentProgressText && incomingProgressText) {
      currentProgressText.innerHTML = incomingProgressText.innerHTML;
    }

    if (currentProgressBarFill && incomingProgressBarFill) {
      currentProgressBarFill.style.width = incomingProgressBarFill.style.width;
    }

    if (incomingButton && incomingButton.dataset.nextUrl) {
      button.dataset.nextUrl = incomingButton.dataset.nextUrl;
      button.dataset.loading = 'false';
      button.disabled = false;

      if (text) text.textContent = 'Load more';
      if (spinner) spinner.hidden = true;
    } else {
      button.closest('.collection-load-more')?.remove();
    }
  } catch (error) {
    console.error('Load more failed:', error);

    button.dataset.loading = 'false';
    button.disabled = false;

    if (text) text.textContent = 'Load more';
    if (spinner) spinner.hidden = true;
  }
});